import { type FC, memo } from 'react';
import StandardJackpot from '../../StandardJackpot';
import type { StandardJackpotProps } from 'features/jackpots';
// import { useSeasonalBranding } from '../../../../../store/featureFlags/featureFlagsStore';
import styles from './BellLinkBoost.module.css';

const BellLinkBoostJackpot: FC<StandardJackpotProps> = (props) => {
  // const seasonalBranding = useSeasonalBranding();
  // TODO: Uncomment when seasonal branding assets are added

  const bellLinkBoostIcons = {
    // panel: seasonalBranding ? `/brandings/${seasonalBranding}/group_bell_link_boost/panel` : '/group_bell_link_boost/panel',
    panel: '/group_bell_link_boost/panel',
    grand: '/group_bell_link_boost/grand',
    major: '/group_bell_link_boost/major',
    minor: '/group_bell_link_boost/minor',
    mini: '/group_bell_link_boost/mini',
  };

  return (
    <StandardJackpot
      {...props}
      icons={bellLinkBoostIcons}
      className={styles['bellLinkBoostTheme']}
    />
  );
};

export default memo(BellLinkBoostJackpot);
